import { profile } from "./profile";
import { checkout } from "./checkout";

const fr = {
  profile,
  checkout,
};
export default fr;
